import { cn } from '../../utils';

type WaveAnimationProps = {
    height?: string;
    waveNumber?: number;
    className?: string | object;
    width?: string;
};

export default function WaveAnimation({
    height = '90px',
    className,
    waveNumber = 2,
    width = '100vw',
}: WaveAnimationProps) {
    const elements = [];

    const calculateStyle = (index: number) => {
        const isEven = index % 2 === 0;
        return {
            height: isEven ? '100%' : `80%`,
            animationDuration: isEven ? '60s' : `${index * 20}s`,
            animationDelay: index === 0 ? '-10s' : `-${index}s`,
            animationDirection: isEven ? 'normal' : 'reverse',
            opacity: isEven ? 0.08 : 0.06,
        };
    };

    for (let index = 0; index < waveNumber; index++) {
        elements.push(
            <div
                key={index}
                className="wave alli-absolute alli-bottom-0 alli-h-full"
                style={calculateStyle(index)}
            />,
        );
    }

    return (
        <div
            data-testid="WaveAnimation"
            className="alli-relative alli-w-full"
            style={{ height: height, width: width }}>
            <div
                className={cn(
                    `alli-absolute alli-bottom-0 alli-left-0 alli-right-0 alli-h-full alli-w-full alli-overflow-x-hidden`,
                    className,
                )}>
                {elements}
            </div>
        </div>
    );
}
